import React from "react";
const PlayIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 512 512"
        {...props}
    >
        <path
            d="M112 111v290c0 17.44 17 28.52 31 20.16l247.9-148.37c12.12-7.25 12.12-26.33 0-33.58L143 90.84c-14-8.36-31 2.72-31 20.16z"
            fill="currentColor"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth="32"
        />
    </svg>
);

export default PlayIcon;
